import React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import moment from 'moment'
import DateUtils from './utils/DateUtils';

class WeekDates extends React.Component {

  constructor () {
    super()
    this.state = {
      appointments: [],
      calendarEvents: new Map(),
      users: [],
      usersMap: new Map(),
      user: null,
      week: []
    }
  }

  render() {

    if ( this.state.week===[] || this.state.week[0]===undefined ) {
      return (
        <div className="container waitDiv">
          <div ref="waitAnimDiv" className="waitAnim"> </div>
        </div>
      )
    }

    let date0 = moment( DateUtils.dateStrToDate(this.state.week[0]) ).add(7*this.props.weekMod, "days").format('DD/MM/YYYY')
    let date1 = moment( DateUtils.dateStrToDate(this.state.week[1]) ).add(7*this.props.weekMod, "days").format('DD/MM/YYYY')
    let date2 = moment( DateUtils.dateStrToDate(this.state.week[2]) ).add(7*this.props.weekMod, "days").format('DD/MM/YYYY')
    let date3 = moment( DateUtils.dateStrToDate(this.state.week[3]) ).add(7*this.props.weekMod, "days").format('DD/MM/YYYY')
    let date4 = moment( DateUtils.dateStrToDate(this.state.week[4]) ).add(7*this.props.weekMod, "days").format('DD/MM/YYYY')
    let date5 = moment( DateUtils.dateStrToDate(this.state.week[5]) ).add(7*this.props.weekMod, "days").format('DD/MM/YYYY')
    let date6 = moment( DateUtils.dateStrToDate(this.state.week[6]) ).add(7*this.props.weekMod, "days").format('DD/MM/YYYY')

    const monthStr = DateUtils.getMonthStr( parseInt( date6.substring(3,5) ) )

    return (
      <div>
        <div className="row monthTitleDiv">
          <div className="monthTitle">
            <h3 className="monthTitle"><b>{monthStr}</b></h3>
            <br/>
            <br/>
          </div>
        </div>
        <div className="row">
          <table className="weekTable">
            <thead>
              <tr>
                <th className="weekHeader">
                  <h1 className="weekDayTitle">L</h1>
                  {date0}
                </th>
                <th className="weekHeader">
                  <h1 className="weekDayTitle">M</h1>
                  {date1}
                </th>
                <th className="weekHeader">
                  <h1 className="weekDayTitle">X</h1>
                  {date2}
                </th>
                <th className="weekHeader">
                  <h1 className="weekDayTitle">J</h1>
                  {date3}
                </th>
                <th className="weekHeader">
                  <h1 className="weekDayTitle">V</h1>
                  {date4}
                </th>
                <th className="weekHeader">
                  <h1 className="weekDayTitle">S</h1>
                  {date5}
                </th>
                <th className="weekHeader">
                  <h1 className="weekDayTitle">D</h1>
                  {date6}
                </th>
              </tr>
            </thead>
            <tbody>
              {
                DateUtils.getHoursArray().map ( h => {
                  return ( 
                    <tr key={h}>
                    {
                      this.state.week.map ( d => {
                        const day = moment(DateUtils.dateStrToDate(d)).add(7*this.props.weekMod, "days").format('DD/MM/YYYY')
                        return (
                          
                            <td className="weekTd" key={h+d}> 
                              { 
                                this.state.calendarEvents.get (day) !== undefined ?
                                  this.state.calendarEvents.get (day).map ( e => {
                                    if ( e.time.indexOf (h) !==-1 ) {
                                      let user = e.user 
                                      let userName = e.user
                                      if ( e.userType===undefined || e.userType===0 ) {
                                        user = this.state.usersMap.get(e.user)
                                        userName = user.email
                                        if ( user.name!==undefined ) {
                                          userName = user.name
                                        }
                                      }
                                      return (
                                        <div className="dateCard" key={e} onClick={() => this.props.editAppointment(e)}>{e.time}<br/>{userName}</div>
                                      )
                                    }
                                    return true
                                  })
                                : null
                              } 
                            </td>
                        )
                      }) 
                    }
                    </tr>
                  )
                })
              }
            </tbody>
          </table>

        </div>
      </div>
    )
  }

  componentDidMount () {

    firebase.database().ref("users").on ( 'value', users => {
      let usersList = []
      let usersMap = new Map()
      let userObj = null
      users.forEach ( user => {
        let u = user.val()
        u.key = user.key
        usersMap.set( u.key, u )
        if (u.role==='user'){
          usersList.push(u)
        }
        if ( u.email===firebase.auth().currentUser.email){
          userObj = u
        }
      })
    
      this.setState({
        users: usersList,
        usersMap: usersMap,
        user: userObj,
        week: DateUtils.getWeekArray ()
      })
      
      firebase.database().ref("appointments").on ( 'value', appointments => {
        // TODO: calendarEventsMap deprecated??
        let appointmentsList = []
        let calendarEventsMap = new Map()
        appointments.forEach ( appointment => {
          // store appointment
          let a = appointment.val()
          a.key = appointment.key
          appointmentsList.push(a)
          // store events map by day
          let events = calendarEventsMap.get(a.date)
          if (events===undefined){
            events = []
          }

          if ( userObj!==null && ( userObj.role!=='user' || (userObj.role==='user' && a.user===userObj.key) ) ) {
            events.push(a)
            calendarEventsMap.set(a.date, events)
          }
        })
        this.setState({
          appointments: appointmentsList,
          calendarEvents: calendarEventsMap
        })
      })
    })
  }
}

export default WeekDates
